import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Services from "./components/Services";
import About from "./components/About";
// import Testimonials from "./components/Testimonials";
import Contact from "./components/Contact";
import Store from "./components/Store";
import Footer from "./components/Footer";
import "./App.css";
import PrivacyPolicy from "./components/PrivacyPolicy";
import Recruitment from "./components/Recruitment";
// import Projects from "./components/Projects";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

function ScrollToHash() {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return;
    // Wait a tick so the target section has mounted before we scroll to it.
    const id = setTimeout(() => {
      document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
    }, 0);
    return () => clearTimeout(id);
  }, [hash]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToHash />
      <Header />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Hero />
              <div id="services">
                <Services />
              </div>
              {/* <div id="projects">
              <Projects />
            </div> */}
              <div id="about">
                <About />
              </div>
              <div id="recruitment">
                <Recruitment />
              </div>
              {/* <div id="testimonials">
                <Testimonials />
              </div> */}
              <div id="privacy">
                <PrivacyPolicy />
              </div>
              <div id="contact">
                <Contact />
              </div>
              <Store />
              <Footer />
            </>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
